import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
const serviceProvider = {
    name: 'awsLambda',
    title: 'AWS Lambda',
    description: 'Run code without thinking about servers or clusters. Only pay for what you use.',
    links: [{ title: 'Homepage', url: 'https://aws.amazon.com/lambda/' }],
    serviceType: 'aws',
    createId: value('lambda'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+'
            },
            title: {
                title: 'Name',
                type: 'string'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    awsAccessKeyId: {
                        '@sensitive': true,
                        title: 'AWS Access Key Id',
                        type: 'string'
                    },
                    awsSecretAccessKey: {
                        '@sensitive': true,
                        title: 'AWS Secret Access Key',
                        type: 'string'
                    }
                },
                required: ['awsAccessKeyId', 'awsSecretAccessKey']
            }
        },
        required: ['id', 'title', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'authentication'],
        properties: {
            id: {
                widget: 'singleLineText'
            },
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            authentication: {
                properties: {
                    awsAccessKeyId: {
                        widget: 'sensitiveField'
                    },
                    awsSecretAccessKey: {
                        widget: 'sensitiveField'
                    }
                },
                order: ['awsAccessKeyId', 'awsSecretAccessKey']
            }
        }
    }),
    getConfig: (formData) => updateAuthentication({
        id: formData.id,
        title: formData.title,
        provider: 'awsLambda',
        serviceType: 'aws',
        authenticationType: 'aws'
    }, formData, { type: 'aws' }),
    isCompleteConfig: hasEveryKey(['authentication'])
};
export default serviceProvider;
